import { INTERNAL_ADMIN, SUPER_ADMIN } from "src/components/constant/constant";

// Mirrors the Cedar grant for create/update/toggle_workflow; no UI permission key exists for workflows.
const WORKFLOW_MANAGER_ROLES = [SUPER_ADMIN, INTERNAL_ADMIN];

export const canManageWorkflows = (role?: string | null): boolean =>
  Boolean(role && WORKFLOW_MANAGER_ROLES.includes(role));

export const parseJson = <T>(value: string | null | undefined): T | null => {
  if (!value) return null;
  try {
    return JSON.parse(value) as T;
  } catch {
    return null;
  }
};
